import * as types from '../constants/ActionTypes';

const initState = {
  SelectedL1TopicDetails: '',
  L1Topics: [],
  SelectedL2TopicDetails: '',
  L2Topics: [],
  SelectedL3TopicDetails: '',
  L3Topics: [],
  SelectedL3Article: '',
  L3Articles: [],
  experience: '',
  blacklistedMarketICFFlag: false,
  breadCrumb: [],
  isL3TopicClicked: false,
};

export default function (state = initState, action) {
  switch (action.type) {
    case types.UPDATE_L1_TOPIC_DETAILS:
      return {
        ...state,
        SelectedL1TopicDetails: action.selectedTopic,
        L1Topics: action.allTopics,
        SelectedL2TopicDetails: '',
        L2Topics: [],
        isL3TopicClicked: false,
        L3Topics: [],
        SelectedL3Article: '',
        L3Articles: [],
      };
    case types.UPDATE_L2_SELECTED_TOPIC:
      return {
        ...state,
        SelectedL2TopicDetails: action.selectedSubTopic,
        L3Topics: action.selectedSubTopic.subTopicList,
        SelectedL3Article: '',
        L3Articles: [],
        isL3TopicClicked: false,
      };
    case types.UPDATE_L2_TOPIC_DETAILS:
      return {
        ...state,
        L2Topics: action.topics,
        blacklistedMarketICFFlag: action.blacklistedMarketICFFlag,
        L3Articles: [],
        breadCrumb: [],
        SelectedL3Article: '',
        isL3TopicClicked: false,
      };
    case types.UPDATE_L3_SELECTED_TOPIC:
      return {
        ...state,
        SelectedL3TopicDetails: action.selectedL3SubTopic,
        L3Articles: action.selectedL3SubTopic.faqList,
        breadCrumb: action.breadCrumbItems,
        SelectedL3Article: action.article,
        isL3TopicClicked: true,
      };
    case types.UPDATE_L3_SELECTED_TOPIC_DETAILS:
      return { ...state, SelectedL3TopicDetails: action.selectedL3SubTopic };
    case types.UPDATE_SELECTED_ARTICLE:
      return { ...state, SelectedL3Article: action.article };
    case types.L3_TOPIC_CLICKED:
      return {
        ...state,
        isL3TopicClicked: true,
      };
    case types.RESET_TOPIC_DETAILS:
      return { ...state, ...initState };
    case types.UPDATE_TOPIC_DETAILS:
      return {
        ...state,
        L2Topics: action.topics,
        blacklistedMarketICFFlag: action.blacklistedMarketICFFlag,
        breadCrumb: [],
        SelectedL3Article: '',
        SelectedL2TopicDetails: action.selectedSubTopic,
        L3Topics: action.selectedSubTopic,
        isL3TopicClicked: true,
      };
    default:
      return state;
  }
}
